<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="col-md-12" v-else>
      <div class="row">
        <div class="col-md-3">
          <b-form-group label="Cooperado">
            <multiselect
              label="name"
              track-by="name"
              select-label=""
              :taggable="false"
              :max-height="200"
              :allowEmpty="false"
              :options="cooperadoLkp"
              placeholder="Selecione"
              v-model="selecaoCooperado"
              :disabled="disabledCooperado"
            >
              <span slot="noResult">Nenhum cooperado encontrado</span>
              <span slot="noOptions">Nenhum cooperado disponível</span>
            </multiselect>
          </b-form-group>
        </div>

        <div class="col-md-3">
          <cpfCnpjInput
            :required="true"
            v-model="cpfCnpj"
            :submitted="submit"
            :state="cpfCnpjState"
            :disabled="disabledCpfCnpj || disabledAddCpfCnpj"
            placeholder="Digite CPF ou CNPJ"
            @update:isValid="handleValidState"
            :error-message="mensagemErro || undefined"
            :input-class="disabledCpfCnpj ? 'bg-white opacity-50' : ''"
          />
        </div>

        <div class="col-md-3">
          <b-form-group class="mb-3" label="Nome Completo/Razão Social">
            <b-input-group>
              <b-form-input
                class="rounded"
                :state="state('clienteRural')"
                :disabled="disabledAddCpfCnpj"
                type="text"
                v-model="clienteRural"
                placeholder="Digite o nome completo"
              />
              <b-input-group-append>
                <b-spinner v-if="loadingCpfCnpj" small variant="success" />
              </b-input-group-append>
            </b-input-group>
            <b-form-invalid-feedback :state="state('clienteRural')">
              Nome Completo/Razão Social é obrigatório.
            </b-form-invalid-feedback>
          </b-form-group>
        </div>

        <div class="col-md-3">
          <b-form-group class="mb-3" label="Data de Nascimento">
            <b-input-group>
              <date-picker
                editable
                :confirm="false"
                value-type="date"
                ref="dpNascimento"
                @input="onDateInput"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                :formatter="dateFormatter"
                v-model="dataNascimentoDate"
                @change="onDateChangeAndValidate"
                :input-attr="{ inputmode: 'numeric', maxlength: 10 }"
                :disabled="disabledAddCpfCnpj || dataNascimentoDesabilitado"
              />
              <b-input-group-append>
                <b-spinner v-if="loadingCpfCnpj" small variant="success" />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import cpfCnpjInput from "../formulario/cpfCnpj-input.vue";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins: [clienteRuralMixin],
  components: {
    Multiselect,
    cpfCnpjInput
  },

  props: {
    fotoPerfil: {
      type: Object,
      required: true,
      default: () => ({
        base64: null,
        file: null,
        base64Completo: null,
        nomeArquivo: null
      })
    },
    nextTooltip: { type: String, default: "Avançar" },
    tooltipLocation: { type: String, default: "bottom" },
    showNextButton: { type: Boolean, default: false },
    visibilidadeBotao: { type: Boolean, default: true },
    nextDisabled: { type: Boolean, default: false }
  },

  data() {
    return {
      loading: true,
      cpfCnpj: "",
      submit: false,
      errorMessage: "",
      clienteRural: "",
      cooperadoLkp: [],
      mensagemErro: "",
      modoEdicao: false,
      cpfCnpjState: null,
      dataNascimentoDate: null,
      clienteRuralLkp: [],
      preencheInput: null,
      debounceTimer: null,
      loadingSalvar: false,
      loadingCpfCnpj: false,
      selecaoCooperado: null,
      disabledCpfCnpj: false,
      disabledAddCpfCnpj: false,
      disabledCooperado: false,
      fotoLocal: null,
      localFotoPerfil: {
        type: Object,
        required: true,
        default: () => ({
          base64: null,
          file: null,
          base64Completo: null,
          nomeArquivo: null
        })
      },
      isBuscandoGePessoaExecuting: false,
      isFiltrarClienteRuralExecuting: false,
      jaAlertouMenorIdade: false,
      dateFormatter: {
        stringify: val => {
          if (!(val instanceof Date) || isNaN(val.getTime())) return "";
          const dd = String(val.getDate()).padStart(2, "0");
          const mm = String(val.getMonth() + 1).padStart(2, "0");
          const yyyy = val.getFullYear();
          return `${dd}/${mm}/${yyyy}`;
        },
        // O parse aceita 'dd/mm/yyyy' ou 'ddMMyyyy' e retorna Date local
        parse: input => {
          if (!input) return null;
          const str = String(input).trim();
          const digits = str.replace(/\D/g, "");

          if (digits.length === 8) {
            const dd = Number(digits.slice(0, 2));
            const mm = Number(digits.slice(2, 4));
            const yyyy = Number(digits.slice(4, 8));
            const dt = new Date(yyyy, mm - 1, dd);
            return isNaN(dt.getTime()) ? null : dt;
          }

          if (str.includes("/")) {
            const [d, m, y] = str.split("/");
            const dd = Number(d);
            const mm = Number(m);
            const yyyy = Number(y);
            const dt = new Date(yyyy, mm - 1, dd);
            return isNaN(dt.getTime()) ? null : dt;
          }

          return null;
        }
      },
      dataNascimentoStore: null
    };
  },

  computed: {
    habilitaBotaoSalvar() {
      if (this.modoEdicao) return true;
      const camposPreenchidos =
        this.selecaoCooperado &&
        this.cpfCnpj &&
        this.cpfCnpjState !== false &&
        this.clienteRural.trim() !== "";
      const validacaoOk = !this.$v.$invalid;
      return camposPreenchidos && validacaoOk;
    },
    dataNascimentoDesabilitado() {
      const numero = this.cpfCnpj.replace(/\D/g, "");
      return numero.length === 14;
    }
  },

  watch: {
    async selecaoCooperado(novo, antigo) {
      if (!novo || novo?.value === antigo?.value) return;
      await this.buscaClienteRuralProjetos(novo.value);
      this.salvarCooperadoNoStore();

      this.bloqueadoPelaApi = false;

      this.clienteRural = "";
      this.dataNascimentoDate = null;
      this.preencheInput = null;
      this.cpfCnpjState = null;
      this.mensagemErro = null;
      this.disabledAddCpfCnpj = false;
      this.ultimoCpfValidado = null;

      if (this.cpfCnpj && this.cpfCnpj.replace(/\D/g, "").length >= 11) {
        const apenasNumeros = this.cpfCnpj.replace(/\D/g, "");
        this.filtarClienteRural(apenasNumeros);
      }

      this.emitirEstadoCampos();
    },

    cpfCnpj(newValue) {
      this.debouncedCpfCnpjChange(newValue);
      this.emitirEstadoCampos();
    },

    clienteRural() {
      this.emitirEstadoCampos();
    },

    cpfCnpjState() {
      this.emitirEstadoCampos();
    },

    fotoPerfil: {
      deep: true,
      immediate: true
    },

    dataNascimentoDate(novaData) {
      if (!novaData) {
        this.jaAlertouMenorIdade = false;
        return;
      }
      this.validarMaioridade(novaData);
    },

    disabledAddCpfCnpj(newVal) {
      if (!newVal) {
        this.$nextTick(() => this.anexarMascaraDatePicker());
      }
    },
    dataNascimentoDesabilitado(newVal) {
      if (!newVal) {
        this.$nextTick(() => this.anexarMascaraDatePicker());
      }
    }
  },

  async created() {
    this.loading = true;
    try {
      await this.buscarLkpCooperado();

      const filtro = this.$store.state.filtroClienteRuralAstec;
      const cooperadoLkp = filtro?.cdCooperado ?? null;

      if (cooperadoLkp && this.cooperadoLkp?.length) {
        this.selecaoCooperado = this.cooperadoLkp.find(
          el => el.value === cooperadoLkp
        );
        this.salvarCooperadoNoStore();
      }

      this.disabledCooperado = false;
      this.disabledCpfCnpj = false;
      this.localFotoPerfil = { ...this.fotoPerfil };
      this.debouncedCpfCnpjChange = this.debounce(this.onCpfCnpjChanged, 500);

      if (this.$store.state.clienteRuralAstec) {
        this.modoEdicao = true;
        this.$emit("modoEdicaoAtivo", true);

        const cooperadoEditando = this.$store.state.filtroClienteRuralAstec
          ?.cdCooperado;
        if (cooperadoEditando) {
          this.selecaoCooperado = this.cooperadoLkp.find(
            el => el.value === cooperadoEditando
          );
        }

        this.disabledCooperado = true;
        this.cpfCnpj = this.$store.state.clienteRuralAstec.NRCPFCNPJ ?? null;
        this.disabledCpfCnpj = true;
        this.clienteRural = this.$store.state.clienteRuralAstec.NMRAZAO ?? null;
        this.dataNascimentoStore = this.$store.state.clienteRuralAstec.DTNASCIMENTO;

        const nascBr = this.$store.state.clienteRuralAstec.DTNASCIMENTO;

        if (nascBr) {
          const [dia, mes, ano] = nascBr.split("/");
          const y = Number(ano);
          const m = Number(mes);
          const d = Number(dia);
          const dt = new Date(y, m - 1, d);
          this.dataNascimentoDate = isNaN(dt.getTime()) ? null : dt;
        }

        const sqCliente = this.$store.state.clienteRuralAstec.SQCLIENTE ?? null;
        if (sqCliente) {
          await this.carregarFotoDoCliente(sqCliente);
        } else {
          this.usarFotoPadrao();
        }
      }

      this.emitirEstadoCampos();
    } catch (error) {
      console.error("Erro ao montar componente:", error);
    } finally {
      setTimeout(() => {
        this.loading = false;
        this.$nextTick(() => this.anexarMascaraDatePicker());
      }, 300);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.anexarMascaraDatePicker();
    });
  },

  beforeDestroy() {
    const dp = this.$refs.dpNascimento;
    const inputEl = dp?.$el?.querySelector("input");
    if (inputEl?.__dateMaskCleanup) {
      inputEl.__dateMaskCleanup();
    }
  },

  methods: {
    onDateInput(valorInput) {
      this.dataNascimentoDate = valorInput;
    },
    onDateChangeAndValidate(valorChange) {
      this.dataNascimentoDate = valorChange;
      this.validarMaioridade(valorChange);
    },

    toIsoShort(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) return "";
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },

    calcularIdade(valor) {
      let yyyy, mm, dd;
      if (valor instanceof Date) {
        if (isNaN(valor.getTime())) return 0;
        yyyy = valor.getFullYear();
        mm = valor.getMonth() + 1;
        dd = valor.getDate();
      } else {
        return 0;
      }

      const hoje = new Date();
      const Y = hoje.getFullYear();
      const M = hoje.getMonth() + 1;
      const D = hoje.getDate();

      let idade = Y - yyyy;
      if (M < mm || (M === mm && D < dd)) idade--;
      return idade < 0 ? 0 : idade;
    },

    validarMaioridade(valor) {
      if (!(valor instanceof Date) || isNaN(valor.getTime())) return;
      const idade = this.calcularIdade(valor);
      if (idade < 16) {
        if (!this.jaAlertouMenorIdade) {
          this.$tools.alerta(
            "Cadastro permitido somente para maiores de 16 anos.",
            "warning"
          );
          this.jaAlertouMenorIdade = true;
        }
      } else {
        this.jaAlertouMenorIdade = false;
      }
    },

    state(param) {
      if (this.submit) {
        if (param === "cpfCnpj") {
          const isRequiredValid = !this.$v.cpfCnpj.$invalid;
          if (!isRequiredValid) return false;
          return null;
        }
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },

    async carregarFotoDoCliente(sqCliente) {
      try {
        const fotoBase64 = await this.getClienteRuralFoto(sqCliente);
        if (fotoBase64 && fotoBase64.startsWith("data:image")) {
          this.fotoPerfil = {
            file: null,
            base64: fotoBase64.split(",")[1],
            base64Completo: fotoBase64,
            nomeArquivo: `cliente_${sqCliente}.webp`
          };
          this.$emit("updateFotoPerfil", this.fotoPerfil);
        } else {
          this.usarFotoPadrao();
        }
      } catch (error) {
        this.usarFotoPadrao();
      }
    },

    usarFotoPadrao() {
      console.log("Usando foto padrão");
    },

    emitirEstadoCampos() {
      const estado = {
        cpfCnpj: this.cpfCnpj,
        modoEdicao: this.modoEdicao,
        validacaoOk: !this.$v.$invalid,
        cpfCnpjState: this.cpfCnpjState,
        clienteRural: this.clienteRural,
        habilitado: this.habilitaBotaoSalvar,
        selecaoCooperado: this.selecaoCooperado
      };
      this.$emit("atualizarEstadoBotao", estado);
    },

    async salvarDadosPessoais() {
      this.$emit("atualizarLoading", true);
      try {
        this.loadingSalvar = true;
        this.submit = true;

        this.$v.$touch();
        if (this.$v.$invalid || this.cpfCnpjState === false) {
          this.loadingSalvar = false;
          this.$emit("atualizarLoading", false);
          return;
        }

        this.salvarCooperadoNoStore();

        const dataIso = this.dataNascimentoDate
          ? this.toIsoShort(this.dataNascimentoDate)
          : "";

        const dadosCliente = {
          nm_razao: this.clienteRural,
          cd_cooperado: this.selecaoCooperado?.value || "",
          dataNascimento: dataIso ? `${dataIso} 00:00:00` : null,
          nr_cpf_cnpj: this.cpfCnpj.replace(/\D/g, "")
        };

        const formData = new FormData();
        formData.append("dados_cliente", JSON.stringify(dadosCliente));
        Object.keys(dadosCliente).forEach(key => {
          const value = dadosCliente[key] === null ? "" : dadosCliente[key];
          formData.append(key, value);
        });

        if (
          this.fotoPerfil &&
          (this.fotoPerfil.file || this.fotoPerfil.base64)
        ) {
          if (this.fotoPerfil.file) {
            formData.append("foto", this.fotoPerfil.file);
            formData.append("nm_caminho_foto", this.fotoPerfil.file);
          } else if (this.fotoPerfil.base64) {
            try {
              const base64Data = this.fotoPerfil.base64.startsWith("data:image")
                ? this.fotoPerfil.base64
                : `data:image/jpeg;base64,${this.fotoPerfil.base64}`;

              const blob = this.base64ToBlob(base64Data);
              const fileName = this.fotoPerfil.nomeArquivo || "foto_perfil.jpg";

              formData.append("foto", blob, fileName);
              formData.append("nm_caminho_foto", blob, fileName);
            } catch (error) {
              console.error("Erro ao converter base64:", error);
            }
          }
        } else {
          console.log("Não tem foto para enviar");
        }

        const config = {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 30000
        };

        const idade = this.calcularIdade(this.dataNascimentoDate);
        if (idade < 16) {
          this.$tools.alerta(
            "Cadastro permitido somente para maiores de 16 anos.",
            "warning"
          );
          this.loadingSalvar = false;
          this.$emit("atualizarLoading", false);
          return;
        }

        const response = await this.$http.post(
          "api/astec/insertClienteRural",
          formData,
          config
        );

        if (response.data) {
          this.$store.commit("CLIENTE_RURAL_ASTEC", response.data);
        }

        if (dadosCliente.nm_razao) {
          this.$emit("insertNomeClienteRural", dadosCliente.nm_razao);
          this.$emit("enableTab", "contatos");
        }

        this.disabledCpfCnpj = true;
        this.$emit("dadosSalvos", true);
        this.$tools.alerta("Dados salvos com sucesso", "success");
      } catch (err) {
        console.error("Erro na requisição:", err);
        const errorMessage =
          err.response?.data?.message ||
          err.response?.data?.error ||
          err.message ||
          "Erro ao salvar os dados";
        this.$tools.alerta(errorMessage, "error");
        this.$emit("salvarErro", errorMessage);
      } finally {
        this.$emit("atualizarLoading", false);
        this.loadingSalvar = false;
      }
    },

    receberFotoParaSalvamento(novaFoto) {
      this.fotoLocal = { ...novaFoto };
    },

    enviarFotoParaPai(novaFoto) {
      this.$emit("updateFotoPerfil", novaFoto);
    },

    base64ToBlob(base64) {
      try {
        if (!base64) throw new Error("Base64 está vazio ou undefined");
        const parts = base64.split(";base64,");
        if (parts.length < 2) throw new Error("Formato base64 inválido");

        const contentType = parts[0].split(":")[1];
        const raw = window.atob(parts[1]);
        const uInt8Array = new Uint8Array(raw.length);

        for (let i = 0; i < raw.length; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }

        return new Blob([uInt8Array], { type: contentType });
      } catch (error) {
        console.error("Erro na conversão base64 para blob:", error);
        throw error;
      }
    },

    async buscaClienteRuralProjetos(codCooperado) {
      try {
        const response = await this.$http.get(
          "/api/astec/getLkpClienteRuralProjetos/" + codCooperado
        );

        this.clienteRuralLkp = response.data.map(cliente => ({
          name: cliente.DISPLAY,
          value: cliente.ID,
          cpfCnpj: cliente.NRCPFCNPJ
        }));
        this.$emit("listaClientesCarregada", this.clienteRuralLkp);
      } catch (error) {
        console.error("Erro ao buscar projetos do cooperado:", error);
        this.clienteRuralLkp = [];
      }
    },

    async revalidarCpfAposListaCarregada(cpfCnpjNumeros) {
      if (this.modoEdicao) {
        console.log("Modo edição: pulando revalidação após lista carregada");
        return;
      }

      if (!this.selecaoCooperado?.value) return;

      this.ultimoCpfValidado = cpfCnpjNumeros;

      this.cpfCnpjState = null;
      this.mensagemErro = null;
      this.disabledAddCpfCnpj = false;

      const clienteFiltrado = this.clienteRuralLkp.find(
        cliente =>
          cliente.cpfCnpj &&
          cliente.cpfCnpj.replace(/\D/g, "") === cpfCnpjNumeros
      );

      if (clienteFiltrado) {
        const filtro = {
          cdCooperado: this.selecaoCooperado.value,
          sqCliente: clienteFiltrado.value,
          mes_aniversario: "",
          e_mail: "",
          sq_regiao: null,
          cd_projeto: null,
          safra: null
        };
        await this.buscarItens(filtro);
      } else {
        this.handleValidState(false, true);
        this.disabledAddCpfCnpj = false;
        this.cpfCnpjState = true;
        this.mensagemErro = null;
        this.clienteRural = "";
        this.dataNascimentoDate = null;
        this.preencheInput = null;

        await this.buscaTableGePessoa(cpfCnpjNumeros);
      }
    },

    async revalidarCpfComNovoCooperado(cpfCnpjNumeros) {
      if (this.modoEdicao) {
        return;
      }

      if (!this.selecaoCooperado?.value) return;
      this.ultimoCpfValidado = cpfCnpjNumeros;
      this.cpfCnpjState = null;
      this.mensagemErro = null;
      this.disabledAddCpfCnpj = false;
      await new Promise(resolve => setTimeout(resolve, 500));

      const clienteFiltrado = this.clienteRuralLkp.find(
        cliente =>
          cliente.cpfCnpj &&
          cliente.cpfCnpj.replace(/\D/g, "") === cpfCnpjNumeros
      );

      if (clienteFiltrado) {
        const filtro = {
          cdCooperado: this.selecaoCooperado.value,
          sqCliente: clienteFiltrado.value,
          mes_aniversario: "",
          e_mail: "",
          sq_regiao: null,
          cd_projeto: null,
          safra: null
        };
        await this.buscarItens(filtro);
      } else {
        this.handleValidState(false, true);
        this.disabledAddCpfCnpj = false;
        this.cpfCnpjState = true;
        this.mensagemErro = null;

        this.clienteRural = "";
        this.dataNascimentoDate = null;
        this.preencheInput = null;

        await this.buscaTableGePessoa(cpfCnpjNumeros);
      }
    },

    async filtarClienteRural(valueCpfCnpj) {
      if (this.modoEdicao) {
        const apenasNumeros = valueCpfCnpj.replace(/\D/g, "");
        if (!this.clienteRural || !this.dataNascimentoDate) {
          await this.buscaTableGePessoa(apenasNumeros);
        }
        return;
      }

      if (this.isFiltrarClienteRuralExecuting) return;
      this.isFiltrarClienteRuralExecuting = true;

      try {
        const apenasNumeros = valueCpfCnpj.replace(/\D/g, "");
        const clienteFiltrado = this.clienteRuralLkp.find(cliente => {
          if (cliente.cpfCnpj) {
            const cpfCnpjCliente = cliente.cpfCnpj.replace(/\D/g, "");
            return cpfCnpjCliente === apenasNumeros;
          }
          return false;
        });

        if (clienteFiltrado) {
          const filtro = {
            cdCooperado: this.selecaoCooperado?.value ?? "",
            sqCliente: clienteFiltrado.value,
            mes_aniversario: "",
            e_mail: "",
            sq_regiao: null,
            cd_projeto: null,
            safra: null
          };
          await this.buscarItens(filtro);
        } else {
          this.cpfCnpjState = true;
          this.mensagemErro = null;
          this.disabledAddCpfCnpj = false;

          await this.buscaTableGePessoa(apenasNumeros);
        }

        // Sempre buscar dados de GePessoa para preencher os campos
        await this.buscaTableGePessoa(apenasNumeros);
      } finally {
        this.isFiltrarClienteRuralExecuting = false;
      }
    },

    async buscarItens(filtroCliente) {
      try {
        this.podeEmitirValidacao = false;

        const response = await this.$http.post(
          "/api/astec/getClienteRuralLista",
          filtroCliente
        );

        if (response.data && response.data.length > 0) {
          this.$tools.alerta(
            "Este Cliente Rural já está cadastrado em sua carteira de clientes. Utilize o filtro para realizar as manutenções cadastrais.",
            "warning"
          );
          await new Promise(resolve => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) {
              const observer = new MutationObserver(() => {
                const stillExists = document.querySelector(".swal2-container");
                if (!stillExists) {
                  observer.disconnect();
                  resolve();
                }
              });
              observer.observe(document.body, {
                childList: true,
                subtree: true
              });
            } else {
              setTimeout(resolve, 4000);
            }
          });
          this.handleValidState(true, false);
          this.$forceUpdate();
          this.disabledAddCpfCnpj = true;
        }
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
        this.$tools.alerta(
          error.response?.data?.message || "Erro desconhecido",
          "error"
        );
      } finally {
        this.podeEmitirValidacao = true;
      }
    },

    async buscaTableGePessoa(filtroCliente) {
      if (this.isBuscandoGePessoaExecuting) return;
      this.isBuscandoGePessoaExecuting = true;

      try {
        this.loadingCpfCnpj = true;
        let clienteCpfCnpj = filtroCliente.replace(/\D/g, "");

        const response = await this.$http.get(
          `/api/astec/getTableGePessoa/${clienteCpfCnpj}`
        );
        this.preencheInput = response.data;
        this.preencherCampos();
      } finally {
        this.loadingCpfCnpj = false;
        this.isBuscandoGePessoaExecuting = false;
      }
    },

    debounce(func, wait) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, wait);
      };
    },

    onCpfCnpjChanged(value) {
      const apenasNumeros = value.replace(/\D/g, "");
      if (apenasNumeros.length < 11) return;
      if (apenasNumeros.length === 11 || apenasNumeros.length === 14) {
        if (!this.loadingCpfCnpj) {
          this.filtarClienteRural(apenasNumeros);
          this.buscaTableGePessoa(apenasNumeros);
        }
      }
    },

    preencherCampos() {
      if (!this.preencheInput) {
        return;
      }

      this.clienteRural = this.preencheInput.nm_razao ?? "";
      const data = this.preencheInput.dt_nasc ?? this.dataNascimentoStore;
      if (data) {
        const [dia, mes, ano] = data.split("/");
        const y = Number(ano);
        const m = Number(mes);
        const d = Number(dia);
        const dt = new Date(y, m - 1, d);
        this.dataNascimentoDate = isNaN(dt.getTime()) ? null : dt;
      }
    },

    handleValidState(isValid, fromApi) {
      if (fromApi === false) {
        this.cpfCnpjState = false;
        this.mensagemErro = "CPF / CNPJ já cadastrado.";
        this.bloqueadoPelaApi = true;
        return;
      }

      if (this.bloqueadoPelaApi && !fromApi) {
        return;
      }

      if (isValid === false) {
        this.cpfCnpjState = false;
        this.mensagemErro = "CPF / CNPJ inválido.";
      } else {
        this.cpfCnpjState = true;
        this.mensagemErro = null;
      }
    },

    salvarCooperadoNoStore() {
      if (!this.selecaoCooperado) return;
      const filtroAtual = this.$store.state.filtroClienteRuralAstec || {};
      const novoFiltro = {
        ...filtroAtual,
        cdCooperado: this.selecaoCooperado?.value || null
      };
      this.$store.commit("PARAMETROS_FILTRO_CLIENTE_RURAL_ASTEC", novoFiltro);
    },

    /**
     * ATUALIZAÇÃO: Anexa máscara DD/MM/YYYY ao input interno do vue2-datepicker.
     * - A máscara é aplicada conforme o usuário digita (input/blur).
     * - Atualiza o v-model (Date) apenas quando a data estiver completa (10 chars).
     */
    anexarMascaraDatePicker() {
      const dp = this.$refs.dpNascimento;
      if (!dp) return;

      const inputEl = dp.$el?.querySelector("input");
      if (!inputEl) return;

      // Evita listeners duplicados
      if (inputEl.__hasDateMaskListener) return;
      inputEl.__hasDateMaskListener = true;

      const aplicarMascara = raw => {
        const digits = String(raw || "")
          .replace(/\D/g, "")
          .slice(0, 8);

        let out = "";
        if (digits.length <= 2) {
          out = digits;
        } else if (digits.length <= 4) {
          out = digits.slice(0, 2) + "/" + digits.slice(2);
        } else {
          out =
            digits.slice(0, 2) +
            "/" +
            digits.slice(2, 4) +
            "/" +
            digits.slice(4);
        }

        return out;
      };

      const atualizarModeloSeCompleto = masked => {
        if (masked.length === 10) {
          const parsed = this.dateFormatter.parse(masked);
          this.dataNascimentoDate = parsed || null;
        }
      };

      const onInput = e => {
        const masked = aplicarMascara(e.target.value);
        e.target.value = masked;
        atualizarModeloSeCompleto(masked);
      };

      const onBlur = e => {
        const masked = aplicarMascara(e.target.value);
        e.target.value = masked;
        atualizarModeloSeCompleto(masked);
      };

      inputEl.addEventListener("input", onInput);
      inputEl.addEventListener("blur", onBlur);

      // Cleanup para evitar memory leaks em re-render/destruição
      inputEl.__dateMaskCleanup = () => {
        inputEl.removeEventListener("input", onInput);
        inputEl.removeEventListener("blur", onBlur);
        inputEl.__hasDateMaskListener = false;
      };
    }
  },

  validations: {
    cpfCnpj: { required },
    clienteRural: { required },
    selecaoCooperado: { required }
  }
};
</script>

<style lang="scss" scoped>
.input-group-append {
  right: 3%;
  height: 100%;
  display: flex;
  position: absolute;
  align-items: center;
}
</style>
